class PerformanceMonitor {
  private loadTimes = new Map<string, number>();
  private startTimes = new Map<string, number>();

  // Start timing an operation
  startTiming(key: string): void {
    this.startTimes.set(key, performance.now());
  }

  // End timing and record the duration
  endTiming(key: string): number {
    const startTime = this.startTimes.get(key);
    if (!startTime) return 0;

    const duration = performance.now() - startTime;
    this.loadTimes.set(key, duration);
    this.startTimes.delete(key);

    console.log(`⏱️ ${key}: ${duration.toFixed(2)}ms`);
    return duration;
  }

  // Get average load time for a type of operation
  getAverageLoadTime(prefix: string): number {
    const relevantTimes = Array.from(this.loadTimes.entries())
      .filter(([key]) => key.startsWith(prefix))
      .map(([, time]) => time);

    if (relevantTimes.length === 0) return 0;
    return relevantTimes.reduce((sum, time) => sum + time, 0) / relevantTimes.length;
  }

  // Get performance stats
  getStats() {
    return {
      totalOperations: this.loadTimes.size,
      averageImageLoad: this.getAverageLoadTime('image_'),
      averageVideoLoad: this.getAverageLoadTime('video_'),
      averagePageLoad: this.getAverageLoadTime('page_'),
      allTimes: Object.fromEntries(this.loadTimes),
    };
  }

  // Clear all recorded times
  clear(): void {
    this.loadTimes.clear();
    this.startTimes.clear();
  }

  // Log performance summary
  logSummary(): void {
    const stats = this.getStats();
    console.group('📊 Performance Summary');
    console.log('Total operations:', stats.totalOperations);
    console.log('Average image load:', `${stats.averageImageLoad.toFixed(2)}ms`);
    console.log('Average video load:', `${stats.averageVideoLoad.toFixed(2)}ms`);
    console.log('Average page load:', `${stats.averagePageLoad.toFixed(2)}ms`);
    console.groupEnd();
  }
}

export const performanceMonitor = new PerformanceMonitor();